import banner_card_icon_1 from "../../../../public_images/BannerCardIcon1.svg";

export default {
  title: 'Components/DDA Cards/Banner Card/Banner Card',
  tags: ['autodocs'],
  argTypes: {
    banner_card_type: {
      control: { type: 'select' },
      options: ['button','anchor'],
      description: 'Input status of the input field',
    },
    banner_card_url: {
      control: 'text',
      description: 'ID for the banner card',
    },
    banner_card_id: {
      control: 'text',
      description: 'ID for the banner card',
    },
    image_src: {
      control: 'text',
      description: 'Path to the image to display in the banner card',
    },
    image_alt: {
      control: 'text',
      description: 'Alternative text for the image',
    },
    banner_card_title: {
      control: 'text',
      description: 'Banner card title text',
    },
    banner_card_description: {
      control: 'text',
      description: 'Banner card description text',
    },
    custom_class: {
      control: 'text',
      description: 'Additional custom class for the card',
    },
    component_mode: {
      control: 'check',
      options: ['light-mode'],
      description: 'Mode for the banner card (e.g., light-mode)',
    },
    banner_card_value: {           // updated here
      control: 'text',
      description: 'Optional value to emit with the event',
    },
    banner_card_name: {            // updated here
      control: 'text',
      description: 'Optional name to emit with the event',
    },
  },
  parameters: {
    docs: {
      description: {
        component: `
Use the \`dda-banner-card\` component as shown below:

\`\`\`html
<dda-banner-card
  banner_card_type="button"
  image_src="https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcSvhlzYedWoCSkLB2HFQ87P5gPjCmJqmTt8vw&s"
  image_alt="image alt"
  banner_card_title="Card Title"
  banner_card_description="Lorem Ipsum..."
  banner_card_id="exampleId"
  custom_class=""
  component_mode=""
  banner_card_value="optional value"
  banner_card_name="optional name"
></dda-banner-card>
\`\`\`

This component uses a \`<button>\` element and emits a \`cardClick\` event with details including \`id\`, \`value\`, and \`name\` when clicked.
        `,
      },
    },
  },
};

const Template = (args) => {
  const { cardClick, ...rest } = args;

  const attributes = Object.entries(rest)
    .filter(([_, value]) => value !== undefined && value !== '')
    .map(([key, value]) => `${key}="${value}"`)
    .join(' ');

  return `
    <dda-banner-card ${attributes}></dda-banner-card>
    <script>
      const el = document.querySelector('dda-banner-card');
      if (el) {
        el.addEventListener('cardClick', (event) => {
          console.log('Card clicked event details:', event.detail);
        });
      }
    </script>
  `;
};

export const Default = Template.bind({});
Default.args = {
  // banner_card_type: 'button',
  banner_card_id: 'bannerCardOne',
  banner_card_title: 'Card Title',
  image_src: banner_card_icon_1,
  image_alt: 'image alt',
  banner_card_description: 'Lorem Ipsum is simply dummy text of the printing and typesetting industry.',
  custom_class: 'classname',
  component_mode: 'normal',
  banner_card_value: 'Card Title',    // replaced here
  banner_card_name: 'bannerCardOne',  // replaced here
};
